import { axiosPost } from '@/api/AxiosApi';
import { deviceInfo } from '@/component/users/common/Device';

export type oauthTokenProps = {
  code: string;
  state: string;
};

// sns 로그인 시도
export const oauthToken = async (aData: oauthTokenProps) => {
  const info = deviceInfo();
  const payload = {
    path: `/v1/auth/oauthToken`,
    body: { ...aData, ...info },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
